import HiddenChats from '@/screens/HiddenChats';

export default function PrivateChatHiddenIndexRoute() {
  return <HiddenChats />;
}
